<template>

  <div>
    <b-card no-body>
      <b-card-body fluid="xl">
        <b-form @submit.stop.prevent="onSubmit">
          <b-row>
            <b-col cols="6">
              <b-form-group label="Satsangi Id/SNo" label-for="idNumber">
                <b-form-input id="idNumber" name="idNumber" v-model.trim="form.idNumber" autofocus />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Satsangi Name" label-for="name">
                <b-form-input
                  id="name"
                  :state="validateState('name')"
                  aria-describedby="liveFeedbackName"
                  name="name"
                  v-model.trim="$v.form.name.$model"
                />
              </b-form-group>
              <b-form-invalid-feedback id="liveFeedbackName">Please only enter characters.</b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Satsagi DOB" label-for="dob">
                <b-form-datepicker
                  id="dob"
                  name="dob"
                  v-model.trim="form.dob"
                  placeholder="DD/MM/YYYY"
                  today-button
                  reset-button
                  close-button
                  show-decade-nav

                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                />
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Satsangi Father/Husband Name" label-for="fatherHus">
                <b-form-input
                  id="fatherHus"
                  :state="validateState('fatherHus')"
                  aria-describedby="liveFeedbackFatherHus"
                  name="fatherHus"
                  v-model.trim="$v.form.fatherHus.$model"
                />
                <b-form-invalid-feedback id="liveFeedbackFatherHus">Please only enter characters.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Satsangi Mobile Number" label-for="mobileNumber">
                <b-form-input
                  id="mobileNumber"
                  name="mobileNumber"
                  :state="validateState('mobileNumber')"
                  maxlength="12"
                  aria-describedby="liveFeedbackMobileNumber"
                  v-model="$v.form.mobileNumber.$model"
                />
                <b-form-invalid-feedback id="liveFeedbackMobileNumber">Please only enter numbers.</b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Satsangi City" label-for="city">
                <b-form-input
                  id="city"
                  name="city"
                  :state="validateState('city')"
                  aria-describedby="liveFeedbackCity"
                  v-model.trim="$v.form.city.$model"
                />
              </b-form-group>
              <b-form-invalid-feedback id="liveFeedbackCity">Please only enter characters.</b-form-invalid-feedback>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6" class="mw3">
              <b-button @click="searchSatsangi" :disabled="$v.form.$invalid">Search Satsangi</b-button>
            </b-col>
            <b-col cols="6" class="mw3">
              <b-button @click="reset">Reset</b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>
    <b-row>
      <b-col>
        <b-table
          v-if="foundSatsangis.length > 0"
          :items="foundSatsangis"
          :fields="fields"
          striped
          responsive="sm"
          :current-page="currentPage" :per-page="perPage"
        >
          <template v-slot:cell(actions)="row">
            <b-button size="sm" @click="selectedSatsangi(row.item)" class="mr-2">Select Satsangi</b-button>
          </template>
        </b-table>
    </b-col>
  </b-row>
  <b-row v-if="foundSatsangis!=null && Object.keys(foundSatsangis).length > 0" class="text-center">
    <b-col cols="12" class="my-1">
      <b-pagination
         v-model="currentPage"
         :total-rows="totalRows"
         :per-page="perPage"
         align="fill"
         class="my-0">
     </b-pagination>
    </b-col>
  </b-row>

  </div>
</template>


<script>
import Vue from "vue";
import {
  alpha,
  minLength,
  maxLength,
  numeric,
  helpers
} from "vuelidate/lib/validators";

const searchShape = {
  idNumber: null,
  name: null,
  dob: null,
  fatherHus: null,
  mobileNumber: null,
  city: null
};
const alpha_space = helpers.regex("alpha_space", /^[a-zA-Z\s]*$/);

export default {
  name: "SearchSatsangiModal",
  data: function() {
    return {
      fields: [
        { key: "name", label: "Satsangi Name" },
        { key: "fatherHus", label: "Father/Husband" },
        { key: "dob", label: "Date of Birth" },
        { key: "card", label: "ID Number" },
        { key: "actions", label: "Actions" }
      ],
      foundSatsangis: [],
      currentPage: 1,
      perPage: 20,
      totalRows: 1,
      form: Object.assign({}, searchShape)
    };
  },
  validations: {
    form: {
      name: {
        alpha_space
      },

      fatherHus: { alpha_space },
      mobileNumber: {
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(12)
      },
      city: { alpha_space }
    }
  },
  methods: {
    searchSatsangi() {
      if (this.validate()) {
        this.$nextTick(() => {
          let params = {};
          if(this.form.name){
            params.name = this.form.name;
          }
          if(this.form.idNumber){
            params.idNumber = this.form.idNumber;
          }
          if(this.form.dob){
            params.dob = this.form.dob;
          }
          if(this.form.fatherHus){
            params.fatherHus = this.form.fatherHus;
          }
          if(this.form.city){
            params.city = this.form.city;
          }
          console.log(params);
          this.$store
            .dispatch('pos/searchCustomer', params)
            .then(response => {
              if (response.data.success == false) {
                this.showErrorMsg({
                  message: response.data.error
                })
              } else {
                this.foundSatsangis = response.data.data.data;
                this.currentPage = 1;
                this.totalRows = this.foundSatsangis.length;
                if(this.foundSatsangis.length == 0){
                  this.showSuccessMsg({
                    message: 'No records found for given criteria.'
                  });
                }
              }
            })
            .catch(error => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else if (error.response.status == 422) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
              }
            })
        })
      }
    },
    reset() {
      this.form = Object.assign({}, searchShape);
    },
    validate() {
      this.$v.$touch()
      return !this.$v.form.$anyError
    },
    selectedSatsangi(item) {
      const tempSelectedSatsangi = JSON.parse(JSON.stringify(item));
      this.$emit("success", tempSelectedSatsangi);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    }
  }
};
</script>
